export const processCellCallback = (params) => {
  let res;
  const { column, node: { data }, value } = params;
  if (params.column.colDef && params.column.colDef.valueFormatter) {
    res = params.column.colDef.valueFormatter({ column, data, value });
  } else if (params.column.colDef && params.column.colDef.valueGetter) {
    res = params.column.colDef.valueGetter({ column, data, value });
  } else {
    res = params.value;
  }
  return res;
};

export default function exportGrid({
  actionAfterExport,
  excludeForExport,
  exportFileName,
  gridApi,
  gridId
}) {
  // signifies no data in grid so just return
  if (!gridApi) return;

  const excludedColumns = excludeForExport || ['selector', 'possibleActions', 'actions', 'id'];
  const { allDisplayedColumns, displayedColumns } = gridApi.csvCreator.columnController;
  /* ag-grid updated their api, so including both names for backwards compat */
  const columns = allDisplayedColumns || displayedColumns;
  const columnKeys = columns.map((col) => (!excludedColumns.includes(col.colId)
    ? col.colId
    : null));

  gridApi.exportDataAsCsv({
    columnKeys,
    fileName: exportFileName || gridId,
    processCellCallback
  });

  if (actionAfterExport) {
    actionAfterExport();
  }
}
